<template>
  <div class="user_management">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'用户管理'}]"></breadcrumb>
    <div class="user_management-wrap">
      <div class="user_management-contain">
        <user-top-nav>
          <div>
            <el-select v-model="searchType" placeholder="请选择">
              <el-option
                v-for="item in searchOptions"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
            <el-input
              class="user_management-search_input"
              v-model="search"
              @keyup.enter.native="searchUser()"
              placeholder="输入内容回车搜索"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button @click="addUser()" type="primary">
              <font-awesome-icon :icon="['fas', 'plus']"/>
              <span style="margin-left:5px; font-size:14px;">创建账号</span>
            </el-button>
          </div>
        </user-top-nav>
        <div class="user_management-table_wrap">
          <div class="user_management-table">
            <table>
              <tr>
                <th>ID</th>
                <th>用户名</th>
                <th>部门</th>
                <th>职位</th>
                <th>电话</th>
                <th>代表处</th>
                <th>角色</th>
                <th>操作</th>
              </tr>
              <tr v-for="(item) in userList" :key="item.id" :class="{avaliable:item.available}">
                <td>{{item.id}}</td>
                <td>{{item.name}}</td>
                <td>{{item.departmentName}}</td>
                <td>{{item.postJobName}}</td>
                <td>{{item.phone}}</td>
                <td>{{item.representOfficeName}}</td>
                <td>{{item.roleName}}</td>
                <td>
                  <el-dropdown trigger="click">
                    <div class="user_management-more_button">
                      <i class="el-icon-more"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <div @click="resetPassword(item.id)">
                          <font-awesome-icon
                            style="color:#9b9b9b; margin-right:6px;"
                            :icon="['fas', 'sync']"
                          />重置密码
                        </div>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <div @click="edit(item.id)">
                          <font-awesome-icon
                            style="color:#9b9b9b; margin-right:6px;"
                            :icon="['fas', 'pencil-alt']"
                          />编辑
                        </div>
                      </el-dropdown-item>
                      <el-dropdown-item v-if="item.available===0">
                        <div @click="userStatus(1,item.id)">
                          <font-awesome-icon
                            style="color:#d0021b; margin-right:6px;"
                            :icon="['fas', 'minus-circle']"
                          />关闭
                        </div>
                      </el-dropdown-item>
                      <el-dropdown-item v-else>
                        <div @click="userStatus(0,item.id)">
                          <font-awesome-icon
                            style="color:#39B54A; margin-right:6px;"
                            :icon="['fas', 'play-circle']"
                          />开启
                        </div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </td>
              </tr>
            </table>
          </div>
          <el-pagination
            @current-change="changePage"
            :current-page="page"
            class="user_management-pagination"
            background
            layout="prev, pager, next"
            :total="listSize"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog class="user_management-dialog" title="账户信息" :visible.sync="showForm">
      <el-form class="user_form-wrap" label-position="top" :module="userForm">
        <el-form-item label="账户名称">
          <el-input v-model="userForm.user.name" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="userForm.user.phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="电子邮件">
          <el-input v-model="userForm.user.email" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="用户类型">
          <el-select v-model="userForm.user.userType" placeholder="请选择">
            <el-option
              v-for="item in typeList"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter="25">
          <el-col :span="12">
            <el-form-item label="部门">
              <el-select v-model="userForm.user.departmentId" placeholder="设置部门">
                <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职务">
              <el-select v-model="userForm.user.postJobId" placeholder="设置职务">
                <el-option
                  v-for="item in jobList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="25">
          <el-col :span="12">
            <el-form-item label="代表处">
              <el-select
                @change="representOfficeChange"
                v-model="userForm.user.representOfficeId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in officeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代表处细分">
              <el-select v-model="userForm.areaList" placeholder="请选择" multiple collapse-tags>
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="25">
          <el-col :span="12">
            <el-form-item label="权限设置">
              <el-select v-model="userForm.user.roleId" placeholder="请选择">
                <el-option
                  v-for="item in roleList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="账户状态">
              <el-select v-model="userForm.user.available" placeholder="请选择">
                <el-option
                  v-for="item in availableList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()">提 交</el-button>
        <el-button @click="showForm = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/servies/axios";
import api from "@/servies/api";
import breadcrumb from "@/components/breadcrumb";
import userTopNav from "@/components/userTopNav";
export default {
  components: {
    breadcrumb,
    userTopNav
    },
  data() {
    return {
      page: 1,
      userList: [],
      listSize: 0,
      optionIndex: 0,
      searchOptions: [
        { value: "name", label: "姓名" },
        { value: "departmentName", label: "部门" },
        { value: "postJobName", label: "职位" },
        { value: "phone", label: "电话" }
      ],
      searchType: "name",
      search: "",
      showForm: false,
      areaList: [],
      departmentList: [],
      jobList: [],
      officeList: [],
      roleList: [],
      typeList: [],
      availableList: [{ id: 0, label: "开启" }, { id: 1, label: "关闭" }],
      userForm: {}
    };
  },
  created() {
    this.initForm();
    this.getList();
  },
  mounted() {
    this.initList();
  },
  methods: {
    //初始化表单
    initForm() {
      this.userForm = {
        areaList: [],
        user: {
          available: 0,
          name: "",
          departmentId: "",
          postJobId: "",
          representOfficeId: "",
          roleId: "",
          email: "",
          phone: "",
          userType: ""
        }
      };
    },
    //获取下拉的列表
    initList() {
      Promise.all(
        //获取用户类型列表
        [
          axios.get(api.userTypeList).then(res => {
            if (res.data.code === 0) {
              console.log("获取用户类型列表成功", res.data.result);
              this.typeList = res.data.result;
            } else {
              console.log("获取用户类型列表失败", res.data.msg);
            }
          }),
          //获取部门列
          //获取角色列表
          axios.get(api.roleList).then(res => {
            if (res.data.code === 0) {
              console.log("获取角色列表成功", res.data.result);
              this.roleList = res.data.result;
            } else {
              console.log("获取角色列表失败", res.data.msg);
            }
          }),
          //获取部门列表
          axios.get(api.departList).then(res => {
            if (res.data.code === 0) {
              console.log("获取部门列表成功", res.data.result);
              this.departmentList = res.data.result;
            } else {
              console.log("获取部门列表失败", res.data.msg);
            }
          }),
          //获取职务列表
          axios.get(api.postJobList).then(res => {
            if (res.data.code === 0) {
              console.log("获取职务列表成功", res.data.result);
              this.jobList = res.data.result;
            } else {
              console.log("获取职务列表失败", res.data.msg);
            }
          }),
          //获取代表处
          axios.get(api.officeList).then(res => {
            if (res.data.code === 0) {
              console.log("获取代表处列表成功", res.data.result);
              this.officeList = res.data.result;
            } else {
              console.log("获取代表处列表失败", res.data.msg);
            }
          })
        ]
      )
        .then(() => {})
        .catch(error => {
          console.log(error);
          this.$message.error("网络错误，稍后重试");
        });
    },
    //代表处更改
    representOfficeChange(v) {
      this.getAreaList(v);
    },
    //修改用户
    submit() {
      if (this.userForm.user.id) {
        this.userForm.isAdd = false;
      } else {
        this.userForm.isAdd = true;
      }
      let params = {
        isAdd: this.userForm.isAdd,
        areaCodeList: this.userForm.areaList,
        userForAddOrUpdate: this.userForm.user
      };
      console.log("修改用户入参", params);
      axios
        .post(api.addOrUpdateUser, params)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: "修改用户成功",
              type: "success"
            });
            this.showForm = false;
            this.getList()
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
    getList() {
      let params = {
        departmentName:"",
        name: "",
        page: this.page,
        pageSize: 10,
        phone: "",
        postJobName: "",
        representOfficeName: ""
      };
      params[this.searchType] = this.search;
      axios
        .post(api.userList, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取用户列表成功", res.data.result);
            this.userList = res.data.result.records;
            this.listSize = res.data.result.total;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
    //添加账号
    addUser() {
      this.initForm();
      this.showForm = true;
    },
    searchUser() {
      this.page = 1;
      this.getList();
    },
    changePage(v) {
      this.page = v;
      this.getList();
    },
    edit(id) {
      axios
        .get(api.userDetailForSuper + `?userId=${id}`)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取用户详情成功", res.data.result);
            this.userForm = res.data.result;
            this.userForm.areaList = this.userForm.areaList.map(item => {
              return item.id;
            });
            if(this.userForm.user.representOfficeId){
            this.getAreaList(this.userForm.user.representOfficeId);
            } else{
              this.showForm = true
            }
          } else {
            this.$message.error(this.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
    //获取行政区列表
    getAreaList(v) {
      axios
        .get(api.getAreaList + `?representId=${v}`)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取行政区列表成功", res.data.result);
            this.areaList = res.data.result;
            if (!this.showForm) {
              this.showForm = true;
            }
          } else {
            console.log("获取行政区列表成功", res.data.msg);
          }
        })
        .catch(error => {
          console.log("获取行政区列表失败", error);
        });
    },
    //关闭或开启用户
    userStatus(value, id) {
      axios
        .post(api.trunOnOrOff + `?userId=${id}&available=${value}`)
        .then(res => {
          if (res.data.code === 0) {
            console.log("设置用户状态成功");
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    //重置密码
    resetPassword(id) {
      axios
        .get(api.resetPwd + `?userId=${id}`)
        .then(res => {
          if (res.data.code === 0) {
            console.log("修改密码成功");
            this.$message({
              message: "重置密码成功",
              type: "success"
            });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    }
  }
};
</script>

<style lang="scss">
.user_management {
  .user_management-wrap {
    padding: 77px 30px 0px 30px;
    .user_management-contain {
      border-radius: 4px;
      background: #fff;
      border: 1px solid rgba(230, 227, 227, 1);
      .el-select {
        width: 70px;
        .el-input__inner {
          padding-right: 15px;
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
        }
        .el-input__suffix {
          right: 0px;
        }
      }
      .user_management-search_input {
        margin-right: 33px;
        &.el-input {
          width: 167px;
          .el-input__inner {
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            border-left: 0px;
          }
        }
      }
      .user_management-table_wrap {
        padding: 30px 30px 30px 30px;
        .user_management-table {
          min-height: 470px;
          .avaliable {
            background: #ffebdf;
          }
          tr {
            th {
              height: 40px;
              background: #5d5d5d;
              color: #fff;
            }
            td {
              text-align: center;
              height: 54px;
              .user_management-more_button {
                width: 50px;
                height: 26px;
                cursor: pointer;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                border: 1px solid rgba(220, 223, 230, 1);
                display: flex;
                align-items: center;
                justify-content: center;
                i {
                  color: #9b9b9b;
                }
              }
            }
          }
        }
        .user_management-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
}
.user_management-dialog{
.user_form-wrap {
  .el-form-item {
    .el-form-item__label {
      font-size: 16px;
      color: #4a4a4a;
      line-height: 22px;
      margin-top: 3px;
      padding-bottom: 11px;
    }
    .el-select {
      width: 100%;
    }
  }
}
.el-dialog__header{
  color: #4A4A4A;
  font-weight: 600;
  font-size: 18px;
}
.el-dialog__body{
    padding-top: 6px;
    padding-bottom: 0px;
  }
.el-dialog__footer {
    padding-top: 0px;
    text-align: left;
    .el-button {
      width: 88px;
    }
  }
}
</style>

